/**
 * Web-only: enable CSS scroll-snap for `HomeCarousel`.
 *
 * React Native Web silently drops `snapToOffsets` / `pagingEnabled` from the
 * underlying ScrollView (`node_modules/react-native-web/dist/exports/ScrollView`
 * — neither prop appears in the compiled source). Native platforms handle
 * snapping via those props; on web we get free-scroll instead unless we
 * inject scroll-snap CSS.
 *
 * The carousel tags its track and slide wrappers with
 * `dataSet={{ bpHcTrack: 'true' }}` / `bpHcItem`, which RNW forwards as
 * `data-bp-hc-track` / `data-bp-hc-item` attributes on the underlying DOM.
 * We target those attributes with CSS and get native trackpad-inertia
 * snapping for free — no extra JS, no gesture reimplementation.
 *
 * Mirrors the pattern used by `injectAppFontsWeb.ts`: idempotent, guarded
 * by a fixed style-tag id.
 */

const STYLE_ID = 'bizplus-home-carousel';

export function injectHomeCarouselCssOnce() {
  if (typeof document === 'undefined') return;
  if (document.getElementById(STYLE_ID)) return;

  const css = `
[data-bp-hc-track] {
  scroll-snap-type: x mandatory;
  -webkit-overflow-scrolling: touch;
  scroll-behavior: smooth;
  overscroll-behavior-x: contain;
}
[data-bp-hc-item] {
  scroll-snap-align: center;
  scroll-snap-stop: always;
}
`;

  const style = document.createElement('style');
  style.id = STYLE_ID;
  style.type = 'text/css';
  style.appendChild(document.createTextNode(css));
  document.head.appendChild(style);
}
